const initHeaderMenu = () => {
  const headerToggle = document.querySelector('.navbar-toggler');
  const topMenu = document.querySelector('.header__top-menu');
  const bottomMenu = document.querySelector('.header__bottom-menu');

  if (headerToggle && topMenu && bottomMenu) {
    headerToggle.addEventListener('click', function (event) {
      topMenu.classList.toggle('menu-open');
      bottomMenu.classList.toggle('menu-open');
      headerToggle.classList.toggle('navbar-toggler--open');
    });
  }
};

export default initHeaderMenu;
